//@import dependencies
import React from 'react'
import ReactGA from 'react-ga'
import { Route, useHistory } from 'react-router-dom'
//@end

interface SiteRouteProps {
  component: any
}

const SiteRoute: React.FC<SiteRouteProps> = ({ component: Component, ...rest }) => {
  const history = useHistory()
  React.useEffect(() => {
    ReactGA.pageview(history.location.pathname)
  }, [useHistory])

  const {customs} = {...rest}
  return (
    <>
    <Route
      {...rest}
      render={(props: any) => <Component {...props} {...customs} />}
    />
    </>
  )
}

export default SiteRoute
